/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { ButtonPrimary } from "../../../components/NewButtons";
import { Product } from "../models/product";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { AddPackingItemsDrawer } from "./AddPackingItemsDrawer";

type Props = {
  product: Product;
};

export const AddPackingItemsSelector = ({ product }: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      <ButtonPrimary
        onClick={() => setModalOpen(true)}
        type="button"
        icon={<FontAwesomeIcon icon={solid("plus")} />}
      >
        Add packing item
      </ButtonPrimary>
      <AddPackingItemsDrawer
        isOpen={modalOpen}
        handleOnClose={() => setModalOpen(false)}
        product={product}
      />
    </div>
  );
};
